<template>
  <div id="seo">
    <website-seo
      :form-params="formParams"
      :close-popups="closePopups"
      :pop-ups="popUps"
      :open-alert="openAlert"
    />
    <table-view 
      :component-key="componentKey"
      :end-point="endPoint"
      :column-defs="columnDefs"
      :form-params="formParams"
      :pop-ups="popUps"
      :filters="filters"
      :buttons="buttons"
      :params="params"
      :call-url="callUrl"
      >
    </table-view>
  </div>
</template>

<script>
//import axios from "@/axios.js"
import TableView from '../../components/tableView';
import WebsiteSeo from '../../components/forms/WebsiteSeo.vue';
export default {
  components: {
    TableView,
    WebsiteSeo
  },
  data() {
    let data = {
      componentKey: 0,
      popUps:{popupAddActive: false},
      params:{title:'',formType:'add'},
      formParams:{pageName:'',pageDescription:'',pageTitle:'',formType:'add',pageUrl:''},
      lineDetails:{},
      callUrl: '/api/seo',
      filters:{disable:true},
      columnDefs: [
        {
          headerName: 'Name',
          field: 'pageName',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Url',
          field: 'pageUrl',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Title',
          field: 'pageTitle',
          filter: true,
          width: 250,
        },
        {
          headerName: 'Description',
          field: 'pageDescription',
          filter: true,
          width: 250,
        },
        {
          headerName: 'QuickEdit',
          field:'editQuickPage',
          action: 'editQuickPage',
          filter: false,
          cellStyle: {color: 'orange'},
          cellRenderer: function() {
            return 'Edit';
          }
        }
      ],
      endPoint:'seo',
      buttons:{
          addForm: true,
      },
    }
    return data;
  },
  computed: {
  },
  methods: {
    translate: function(key){
      return this.$t(key);
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    closePopups: function(){
      this.componentKey++;
      this.popUps.popupAddActive = false;
      this.formParams = {formType:'add'};
      this.$forceUpdate();
    }
  },
  mounted() {

  }
}

</script>